import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../lib/cn.js';
export const PressBtn = forwardRef(function PressBtn({ className = 'btn', type = 'button', children, ...rest }, ref) {
    return (_jsx("button", { ref: ref, type: type, className: cn(className, 'j-press'), ...rest, children: children }));
});
